<template>
<div class="chapter">
<div class="inner_page">
<a href="https://earlybirdbooks.com/freebook/index.html?q=629735a9d6c2b37d43e07fbb" target="_blank">
<img alt="image" class="svg_cover" src="image/love.jpg"/></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// love1.vue?094c5607